module.exports = __webpack_public_path__ + "static/media/3.f6348d89.svg";